import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'material-ui/Form';

import Icon from 'material-ui/Icon';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  withIcon: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  withMargin: {
    marginRight: theme.spacing.unit * 2,
  },
});

const RadioWidget = props => {
  const { classes, value, schema: { type }, options: { enumOptions } } = props;
  const displayIcon = type === 'boolean';
  const matchedOptions = enumOptions.filter(opt => opt.value === value);
  const displayValue =
    matchedOptions.length > 0 ? matchedOptions[0].label : null;
  const icon = !displayIcon ? null : value ? 'done' : 'clear';
  return (
    <FormControl margin="normal" fullWidth className={classes.withIcon}>
      {displayIcon && <Icon className={classes.withMargin}>{icon}</Icon>}
      {displayValue}
    </FormControl>
  );
};

RadioWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  options: PropTypes.any,
  value: PropTypes.any,
};

export default withStyles(styles)(RadioWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/RadioWidget.js